import { Skeleton } from "../../../@/components/ui/skeleton";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "../../../@/components/ui/card";
import React, { useEffect, useState } from "react";
import { Overview } from "./OverView";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "store/store";
import { fetchMessageAnalytics, fetchOrderAnalytics, fetchRevenueAnalytics} from "store/AnaliticsSlice";
import { RecentSales } from "./RecentSales";
import AnalyticDrawer from "./AnalyticDrawer";

export default function AnalyticsCardSection() {
  const dispatch: AppDispatch = useDispatch();
  const [activeDrawerCard, setActiveDrawerCard] = useState<string | null>(null);
  const [cardTitles, setCardTitles] = useState<{[key: string]: string}>({
    'Total Revenue': 'Total Revenue',
    'Total Orders': 'Total Orders',
    'Inquiries Answered': 'Inquiries Answered',
    'Users Engaged': 'Users Engaged'
  });

  const { revenue, status, error, dateRange,orderCount, totalMessages } = useSelector(
    (state: RootState) => state.analytics
  );

  const business = useSelector((state: RootState) => state.auth.business);
  const botId = useSelector((state: RootState) => state.auth.selectedBotId);

  useEffect(() => {
    if (business) {
      dispatch(
        fetchRevenueAnalytics({
          business: business,
          startDate: dateRange.startDate,
          endDate: dateRange.endDate,
        })
      );
    }
  }, [dispatch, dateRange, business]);

  useEffect(() => {
    if (business) {
      dispatch(
        fetchOrderAnalytics({
          business: business,
          startDate: dateRange.startDate,
          endDate: dateRange.endDate,
        })
      );
    }
  }, [dispatch, dateRange, business]);
console.log("order details analytic",orderCount)

useEffect(() => {
  if (botId) {
    dispatch(
      fetchMessageAnalytics({
        botId: botId,
        startDate: dateRange.startDate,
        endDate: dateRange.endDate,
      })
    );
  }
}, [dispatch, dateRange, botId]);

  // Function to handle drawer toggle
  const handleDrawerToggle = (cardTitle: string) => {
    setActiveDrawerCard(activeDrawerCard === cardTitle ? null : cardTitle);
  };

  // Function to handle category selection
  const handleCategorySelect = (cardTitle: string, category: string) => {
    setCardTitles(prev => ({
      ...prev,
      [cardTitle]: category
    }));
    setActiveDrawerCard(null);
  };

  // Render method for cards with dynamic content
  const renderCardContent = (cardTitle: string) => {
    switch(cardTitle) {
      case 'Total Revenue':
        return (
          <>
            <div className="text-2xl font-bold">
              {status === "loading" ? (
                <Skeleton className="w-24 h-8 rounded-md" />
              ) : (
                `Rs.${revenue.toFixed(2)}`
              )}
            </div>
            {error && <p className="text-xs text-red-500">{error}</p>}
          </>
        );
      case 'Total Orders':
        return (
          <div className="text-2xl font-bold">
            {orderCount}
          </div>
        );
        case 'Inquiries Answered':
          return (
            <div className="text-2xl font-bold">
              {status === "loading" ? (
                <Skeleton className="w-24 h-8 rounded-md" />
              ) : (
                totalMessages.agent
              )}
            </div>
          );
        case 'Users Engaged':
          return (
            <div className="text-2xl font-bold">
              {status === "loading" ? (
                <Skeleton className="w-24 h-8 rounded-md" />
              ) : (
                totalMessages.user
              )}
            </div>
          );
      default:
        return null;
    }
  };

  return (
    <>
      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
        {['Total Revenue', 'Total Orders', 'Inquiries Answered', 'Users Engaged'].map((cardTitle) => (
          <Card key={cardTitle}>
            <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
              <CardTitle className="text-sm font-medium">
                {cardTitles[cardTitle]}
              </CardTitle>
              <button 
                onClick={() => handleDrawerToggle(cardTitle)}
                className="ml-2 hover:bg-gray-100 rounded-full p-1"
              >
                <svg 
                  xmlns="http://www.w3.org/2000/svg" 
                  width="24" 
                  height="24" 
                  viewBox="0 0 24 24" 
                  fill="none" 
                  stroke="currentColor" 
                  strokeWidth="2" 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  className="h-4 w-4 text-muted-foreground"
                >
                  <path d="m6 9 6 6 6-6"/>
                </svg>
              </button>
            </CardHeader>
            <CardContent>
              {renderCardContent(cardTitle)}
            </CardContent>
            {activeDrawerCard === cardTitle && (
              <AnalyticDrawer
                isDrawerOpen={true}
                setIsDrawerOpen={() => setActiveDrawerCard(null)}
                cardTitle={cardTitle}
                onCategorySelect={(category: any) => handleCategorySelect(cardTitle, category)}
              />
            )}
          </Card>
        ))}
      </div>

      {/* Rest of the existing code remains the same */}
      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-7">
        <Card className="col-span-4">
          <CardHeader>
            <CardTitle>Overview</CardTitle>
          </CardHeader>
          <CardContent className="pl-2">
            <Overview />
          </CardContent>
        </Card>
        <Card className="col-span-3">
          <CardHeader>
            <CardTitle>Recent Sales</CardTitle>
            <CardDescription>You made 265 sales this month.</CardDescription>
          </CardHeader>
          <CardContent>
            <RecentSales />
          </CardContent>
        </Card>
      </div>
    </>
  );
}